import EventEmitter from 'eventemitter3';

//
// Singleton EventEmitter instance to track manifest events.
//
const events = new EventEmitter();

export default events;
